import { LinkResetDigestApi } from 'api/LinkResetDigestApi';
import { backendApiClient } from 'container/backendApiClient';

export const linkResetDigestApi = new LinkResetDigestApi(backendApiClient);
